class RelatedSwiper {
  constructor(el, opt) {
    this.el = el;
    if ($("." + this.el).length > 0) {
      this.event();
    }
  }

  event() {
    const relatedSwiper = "." + this.el;
    const swiper = new Swiper(relatedSwiper, {
      slidesPerView: 2,
      spaceBetween: 8,
      breakpoints: {
        768: {
          slidesPerView: 4,
          spaceBetween: 8,
          slidesPerGroup: 4,
        },
      },
      navigation: {
        nextEl: ".js-related-swiper-next",
        prevEl: ".js-related-swiper-prev",
      },
    })
  }
}